import $ from "jquery";
import { getRoomSpending, getRoomStatus } from "@bd-stores/game-progress";
import convertToBudgetFormat from "./convertToBudgetFormat";

export default class Recap {
    constructor() {
        this.elms = {
            recapPopup: ".js-recap",
            recapTitle: ".js-recap-title",
            recapRoomTitle: ".js-recap-room-title",
            recapDescription: ".js-recap-description",
            recapClose: ".js-briefing-close",
            actionCost: ".recap__item.is-positive .consequence__main",
            additionalSpending:
                ".recap__item:not(.is-positive) .consequence__main",
            blur: ".app-blur",
            finishRecap: ".js-finish-recap",
        };
        this.isVisible = false;
        this.roomData = null;
        this.totalSpending = 0;
    }

    init() {
        this.bindEvents();
        return this;
    }

    bindEvents() {
        $(this.elms.recapClose).on("click", this.hide.bind(this));

        $(document).on("keydown", (e) => {
            if (e.key === "Escape" && this.isVisible) {
                this.hide();
            }
        });
    }

    show(roomData, totalSpending = 0) {
        this.roomData = roomData;
        this.totalSpending = totalSpending;
        this.isVisible = true;
        const currentRoomId = this.roomData.room_id || this.roomData.id;
        const isFinished =
            getRoomStatus(currentRoomId) === "is-status-completed";

        this.updateContent();

        if (isFinished) {
            $(this.elms.blur).addClass("is-blurred");
            $(this.elms.recapPopup).addClass("is-open");
        } else {
            $(this.elms.finishRecap).trigger("click");
        }
    }

    hide() {
        this.isVisible = false;

        $(this.elms.blur).removeClass("is-blurred");

        $(this.elms.recapPopup).removeClass("is-open");
    }

    updateContent() {
        if (!this.roomData) return;

        const currentRoomId = this.roomData.room_id || this.roomData.id;
        const roomSpending = getRoomSpending(currentRoomId);

        $(
            ".recap__list .recap__item:not(.js-recap-action-cost-clone)",
        ).remove();

        const questionIds = roomSpending.budgetAppliedFeedbacks;
        let totalSpending = 0;

        roomSpending.actionCosts.forEach((cost, index) => {
            const clone = $(".js-recap-action-cost-clone").clone();
            clone.removeClass("js-recap-action-cost-clone");
            clone.removeAttr("hidden");
            clone.attr("data-question-id", questionIds[index]);

            const formattedCost = convertToBudgetFormat(cost.toString());
            clone.find(".consequence__sub").text(`Spendings ${index + 1}`);
            clone.find(".consequence__main").text(formattedCost);

            totalSpending += cost;

            $(".spending-list").append(clone);
        });

        roomSpending.incidentCosts.forEach((cost, index) => {
            const clone = $(".js-recap-action-cost-clone").clone();
            clone.removeClass("js-recap-action-cost-clone");
            clone.removeAttr("hidden");
            clone.removeClass("is-positive");

            const formattedCost = convertToBudgetFormat(cost.toString());
            clone
                .find(".consequence__sub")
                .text(`Budget needed to contain incident ${index + 1}`);
            clone.find(".consequence__main").text(formattedCost);

            totalSpending += cost;

            $(".incident-list").append(clone);
        });

        const totalSpendingValue = convertToBudgetFormat(
            totalSpending.toString(),
        );
        $(".js-recap-total-value").text(totalSpendingValue);
    }

    onFinishFeedback(roomData, totalSpending) {
        setTimeout(() => {
            this.show(roomData, totalSpending);
        }, 1500);
    }

    updateSpending(actionCost, additionalSpending) {
        const formattedActionCost = convertToBudgetFormat(
            actionCost.toString(),
        );
        const formattedAdditionalSpending = convertToBudgetFormat(
            additionalSpending.toString(),
        );

        $(this.elms.actionCost).text(formattedActionCost);
        $(this.elms.additionalSpending).text(formattedAdditionalSpending);
    }

    isOpen() {
        return this.isVisible;
    }
}
